import { inject, InjectionToken } from '@angular/core';
import { INotificationStore } from './notification.public';
import { NotificationStore } from './notification.store';

export const NOTIFICATION_STORE = new InjectionToken<INotificationStore>('NOTIFICATION_STORE', {
  providedIn: 'root',
  factory: () => inject(NotificationStore) as INotificationStore,
});